<template>
    <div class="version">v{{version}}</div>
</template>

<script>

import packageJson from '../../../package'

export default {
    name: 'Version',
    data () {
        return {
            version: packageJson.version
        }
    }
}

</script>

<style scoped>
    .version {
        color: #ccc;
        text-align: center;
        background-color: transparent;
        font-size: 14px;
        margin-top: 25px;
        margin-bottom: 15px;
    }
</style>
